<template>
  <div>
    <div
      class="d-flex justify-content-between"
      style="margin-bottom: 10px;"
    >
      <div>
        <el-button
          type="primary"
          size="small"
        >新增检验项</el-button>
        <el-button size="small">批量删除</el-button>
      </div>
      <div>
        <div class="d-inline-block vertical-middle">
          <el-input
            v-model="input"
            placeholder="请输入内容"
            size="small"
          ></el-input>
        </div>

        <i
          class="el-icon-refresh vertical-middle"
          style="margin-left: 10px;"
        ></i>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="date"
        label="日期"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="city"
        label="市区"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            type="text"
            size="small"
          >编辑</el-button>
          <el-button
            type="text"
            size="small"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(row) {
      console.log(row)
    }
  },

  data() {
    return {
      input: '',
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1517 弄',
          zip: 200333
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1519 弄',
          zip: 200333
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        }
      ]
    }
  }
}
</script>

<style>
</style>
